
import React from 'react';
import BookingTable from './BookingTable';

function BookingTabs({
  vehicleId,
  activeTab,
  setActiveTab,
  bookings,
  onEditClick,

  // Bulk booking props
  selectedBookingIds,
  onBookingSelection,
  onSelectAllBookings,
  allCurrentPageSelected,
  onBulkComplete,
}: any) {
  return (
    <>
      {/* ==================== TABS + BULK BUTTON ==================== */}
      <div className="d-flex justify-content-between align-items-center mt-4 mb-3">

        {/* Tabs */}
        <ul className="nav nav-tabs">

          {['Pending', 'Expired', 'Completed', 'Cancel'].map(
            (tab: string) => (
              <li className="nav-item" key={tab}>
                <button
                  type="button"
                  className={`nav-link ${
                    activeTab === tab ? 'active' : ''
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              </li>
            )
          )}

        </ul>

        {/* ==================== BULK COMPLETE BUTTON ==================== */}
        {selectedBookingIds?.length > 0 && (
          <button
            type="button"
            className="btn btn-success"
            onClick={onBulkComplete}
          >
            Complete Bulk Booking (
            {selectedBookingIds.length}
            )
          </button>
        )}

      </div>

      {/* ==================== BOOKING TABLE ==================== */}
      <BookingTable
        data={bookings}
        status={activeTab}
        onEditClick={onEditClick}

        selectedBookingIds={selectedBookingIds}
        onBookingSelection={onBookingSelection}
        onSelectAllBookings={onSelectAllBookings}
        allCurrentPageSelected={allCurrentPageSelected}
      />
    </>
  );
}

export default BookingTabs;





